<script setup>
  import { ref, onBeforeMount, computed} from "vue";
  import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useDataCollectionStore } from "@/stores/dataCollection";
  const company_id = useCompanyStore().companyId;
  const uiStore = useUiStore();
  const dataCollectionStore = useDataCollectionStore();
  const getModalInfo = computed(() => uiStore.modalData);
  const getModalAction = computed(() => uiStore.modalAction);

  const emit = defineEmits(['refresh']);
  let id = ref(null);
  let url_name = ref(null);
  let isSubmitted = ref(false);

  const resetStoreData = () =>{
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);

    document.querySelector(".modal-backdrop").remove();
    document.querySelector(".dx-device-desktop").classList.remove('modal-open');

  };

  const onSubmit = () => {
    isSubmitted.value = true;

    dataCollectionStore.deleteDataCollectionUrl({id : id.value , companyId : company_id})
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });

  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalAction.value == 'delete_data_collection_url'){
      id.value = getModalInfo.value.id;
      url_name.value = getModalInfo.value.url;
    }
  });
</script>
<template>
  <DModal v-if="getModalAction === 'delete_data_collection_url'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Delete URL </template>

    <template #body>
      <div class="delete-text mb-3">
        <span>Are you sure you want to <b>"Delete"</b> the URL <b>{{ url_name }}</b> ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
          <button :disabled="isSubmitted" @click="onSubmit" type="button" class="btn btn-danger add-button mr-30" >
            Delete <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span>
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  
